import { render, staticRenderFns } from "./XInput.vue?vue&type=template&id=4f6e2968&scoped=true&"
import script from "./XInput.vue?vue&type=script&lang=js&"
export * from "./XInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e2968",
  null
  
)

export default component.exports